import { getFinalCommonColumns, initialCommonColumns } from "./index";
import { colSettings } from "../../../common/components/table/agGrid/colSettings";
import { marketDynamicsColumns as mdCols } from "../marketDynamicsColumns";

export const getUnderContractColumns = shouldShowAdditionalInfoCols => [
    ...initialCommonColumns,
    { col: mdCols.price, colDef: colSettings.numberMdVolume },
    { col: mdCols.ucDate, colDef: colSettings.dateSm },
    ...getFinalCommonColumns(shouldShowAdditionalInfoCols),
];
